var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-pc",style:({ position: _vm.appInfo.hasScrollbar ? 'static' : 'fixed' })},[_c('span',[_vm._v("湘ICP备2023037219号")]),_c('span',[_vm._v("岳麓山工业创新中心(实验室)版权所有")])])
}
var staticRenderFns = []

export { render, staticRenderFns }